function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 6.72727C13 11.1818 7 15 7 15C7 15 1 11.1818 1 6.72727C1 5.20831 1.63214 3.75155 2.75736 2.67748C3.88258 1.60341 5.4087 1 7 1C8.5913 1 10.1174 1.60341 11.2426 2.67748C12.3679 3.75155 13 5.20831 13 6.72727Z",
  fill: "#5AC462",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 8.63654C8.10457 8.63654 9 7.78181 9 6.72745C9 5.67309 8.10457 4.81836 7 4.81836C5.89543 4.81836 5 5.67309 5 6.72745C5 7.78181 5.89543 8.63654 7 8.63654Z",
  fill: "#5AC462",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIconLocation1 = function SvgIconLocation1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLocation1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-location-1.db9e8bc2.svg";
export { ForwardRef as ReactComponent };